module.exports = __webpack_public_path__ + "static/media/left.f7a15a09.svg";